export const SOURCE_COMPONENT = {
	ATLASSIAN_SWITCHER: 'atlassianSwitcher',
	TOWNSQUARE_TWC_XFLOW_MODAL: 'townsquareTwcXflowModal',
	TOWNSQUARE_TWC_XFLOW_MODAL_V2: 'townsquareTwcXflowModalV2',
	TWC_LT_BANNER: 'teamworkCollectionLtBanner',
	STORYBOOK: 'storybook',
	TEST: 'test',
} as const;

export const SOURCE_CONTEXT = {
	ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
	SCREEN_SPACE_FLAGS: 'postOfficeScreenSpaceFlagsPlacement',
	TOWNSQUARE_SCREEN_SPACE_FLAGS: 'postOfficeTownsquareScreenSpaceFlagsPlacement',
	TWC_LT_BANNER_TRY_NOW: 'teamworkCollectionLtBannerTryNow',
	STORYBOOK: 'storybook',
	TEST: 'test',
} as const;
